import Raven from 'raven-js';
import { incrementRequestFailureMetric, incrementRequestSuccessMetric } from '../metrics/requestMetrics';
export const fetchDecryptedHighlySensitivePropertyValue = ({
  objectTypeId,
  objectId,
  propertyName,
  timestamp,
  httpClient
}) => {
  return httpClient.get(`inbounddb-objects-sensitive/v1/decrypted/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(objectId)}/${encodeURIComponent(propertyName)}`, timestamp ? {
    query: {
      timestamp
    }
  } : {}).then(response => {
    incrementRequestSuccessMetric('fetchdecryptedhighlysensitivepropertyvalue');
    if (!response) {
      return '';
    }
    return response.value || '';
  }).catch(err => {
    incrementRequestFailureMetric('fetchdecryptedhighlysensitivepropertyvalue', err);
    Raven.captureException(err, {
      extra: {
        apiError: 'DECRYPT_HIGHLY_SENSITIVE_PROPERTY_VALUE_FAILED',
        objectId,
        objectTypeId,
        propertyName
      }
    });
    throw err;
  });
};